const testimonials = [
  {
    quote: "I have tried every journal and card deck on the market. Nothing has ever asked me the questions these do. I ugly-cried on week one and on the second card I pulled. In the best possible way.",
    name: "Talia, M",
    detail: "Lagos",
  },
  {
    quote: "I bought this alongside the HOME and it made every session land so much deeper. I cannot imagine doing this work without them.",
    name: "Deedee",
    detail: "HOME Alumni",
  },
  {
    quote: "I bought this as a gift for my sister. She called me crying after the first card. I then bought one for myself. Buy it. Just buy it.",
    name: "Teeks",
    detail: "Abuja, Nigeria",
  },
];

export default function ShopTestimonialsSection() {
  return (
    <section className="bg-[#6B1E3B] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4 text-center">
          What women are saying
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] text-center mb-14 leading-tight">
          She opened the box thinking it was a gift. She realised it was a turning point.
        </h2>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto">
          {testimonials.map((t) => (
            <div
              key={t.quote}
              className="bg-[#4A1430]/40 backdrop-blur-sm border border-[#3A1030]/30 rounded-lg p-6 md:p-10 flex flex-col"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className="ri-double-quotes-l text-3xl text-[#C9A84C]" />
              </div>
              <p className="font-quote text-base italic text-[#F8EDF2] leading-relaxed mb-6 flex-grow">
                {t.quote}
              </p>
              <div>
                <p className="font-body text-sm font-medium text-[#C9A84C]">
                  {t.name}
                </p>
                <p className="font-body text-xs text-[#C8B8C0]">
                  {t.detail}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}